// extracted by mini-css-extract-plugin
export var checkmark = "features-list-module--checkmark--414c1";
export var featuresList = "features-list-module--featuresList--c1ddc";
export var listText = "features-list-module--listText--07624";
export var xmark = "features-list-module--xmark--87a37";